import React from "react";
import { Toast } from "@sscs/ui";
import { ActionMenu, Dialog } from "Components";
import { useDialog } from "Hooks";
import { apiErrorToast } from "Utils";
import { useDeleteSiteKeyMutation } from "../../services/licensing.api";
import { SiteKey } from "../../types";
import EditSiteKey from "./EditSiteKey";

type SiteKeyActionsProps = {
  siteKey: SiteKey;
  rowIndex: number;
  allocationLimit: number;
};

const SiteKeyActions = ({
  siteKey,
  rowIndex,
  allocationLimit,
}: SiteKeyActionsProps): React.JSX.Element => {
  const deleteSiteKey = useDialog();
  const editSiteKey = useDialog();
  const [deleteSiteKeyMutation] = useDeleteSiteKeyMutation();

  return (
    <>
      <ActionMenu
        id={`site-key-actions-${rowIndex}`}
        items={[
          {
            id: "edit-site-key",
            type: "EDIT",
            text: "Edit site key",
            isDisabled: false,
            onClick: editSiteKey.open,
          },
          {
            id: "delete-site-key",
            type: "DELETE",
            text: "Delete site key",
            isDisabled: false,
            onClick: deleteSiteKey.open,
          },
        ]}
        disabled={siteKey.deleted}
      />
      <EditSiteKey
        isOpen={editSiteKey.isOpen}
        siteKey={siteKey}
        allocationLimit={allocationLimit}
        onClose={editSiteKey.close}
      />
      <Dialog
        title="Delete site key"
        isOpen={deleteSiteKey.isOpen}
        dangerZone={siteKey.site_key}
        onClose={deleteSiteKey.close}
        confirmText="Delete site key"
        onConfirm={async () => {
          try {
            await deleteSiteKeyMutation({
              allocation_id: siteKey.id,
            }).unwrap();

            Toast.show({
              title: (
                <>
                  Deleted site key{" "}
                  <strong>{siteKey.description ?? siteKey.site_key}</strong>
                </>
              ),
              type: "success",
            });
          } catch (error) {
            apiErrorToast(error, "Could delete site key");
          }

          deleteSiteKey.close();
        }}
        onCancel={deleteSiteKey.close}
      >
        <p>
          Are you sure you want to delete the monthly allocation for the{" "}
          <strong>{siteKey.description}</strong> site key? Deleting this
          allocation will display the site key as disabled in the table.
        </p>
        <p>
          CLI uploads can still be performed using this site key, but they will
          use the shared pool allocation.
        </p>
      </Dialog>
    </>
  );
};

export default SiteKeyActions;
